import {NpcEventRel, SpendModeAccountBookItemI, SpendModeEventI} from "../../config/SpendInterface";
import spendGameManager from "../../manager/spendGameManager";
import getOneSpendEventById from "../../config/SpendEventConfig";
import O1HD from "../../../../engines/gameEngine";
import DreamHousePrefab from "../DreamHousePrefab";

const {ccclass, property} = cc._decorator;

/**
 * 投资 item
 */
@ccclass
export default class newProjectItem extends cc.Component {

    @property({type:cc.Sprite,displayName:"npc icon"})
    npcIcon : cc.Sprite = null;
    @property({type:cc.Label,displayName:"npcName"})
    npcName : cc.Label = null;
    @property({type:cc.Label,displayName:"投资金额"})
    investCoinsLb : cc.Label = null;
    @property({type:cc.Label,displayName:"描述"})
    descLb : cc.Label = null;

    //事件 实体
    private mEventEntity : SpendModeEventI;
    private mGameLayer : spendGameManager;
    private mParentScript : DreamHousePrefab;

    onLoad () {

    }

    start () {

    }

    /**
     * 绑定数据
     */
    bindData( itemData : NpcEventRel , gameLayer : spendGameManager, parentScript : DreamHousePrefab){
        //获取事件 实体
        this.mEventEntity = getOneSpendEventById( itemData.eventId );
        this.mGameLayer = gameLayer;
        this.mParentScript = parentScript;

        //加载npc头像
        // O1HD.getManagers().gameMgr.getCurrMode().bundle.load(`res/Image/npc/circleIcon/${this.mEventEntity.belongNpc}`,cc.SpriteFrame,( error, assets : cc.SpriteFrame )=>{
        //     if ( error ) {
        //         console.log("")
        //         return;
        //     }
        //     this.npcIcon.spriteFrame = assets;
        // });

        //npc 名称
        this.npcName.string = `${this.mEventEntity.belongNpc}`;
        this.investCoinsLb.string = `${itemData.investCoins}`;
        this.descLb.string = `${this.mEventEntity.simpleDesc}`;
    }

    /**
     * 追投
     */
    onBtnDetail( e ){
        this.mGameLayer.mGameLayer.openOneEvent( this.mEventEntity.id , ( eventEnd)=>{
            if ( eventEnd == 1 ) {
                O1HD.emit("Page.refreshData");
                O1HD.emit("NpcDreamHouseItem.npcLeave", this.mEventEntity.belongNpc );
                // 判断是否满足 出去的条件
                this.node.removeFromParent();
                this.node.destroy();
            }
        });
    }


}
